import PanoramicView from './panoramic-view'

export default PanoramicView
